function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { Component } from 'react';
import ButtonBase from '@material-ui/core/ButtonBase';
import Icon from '@material-ui/core/Icon';
import Typography from "@material-ui/core/Typography";
import UploadButton from "./MediaButtonUpload";
import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles(theme => ({
  root: {
    border: "1px solid",
    borderColor: "#999",
    borderRadius: 0,
    padding: theme.spacing(1.5),
    display: "flex",
    flexDirection: "column",
    textAlign: "center"
  },
  label: {
    fontFamily: "Akkurat, sans-serif",
    textTransform: "capitalize",
    fontSize: "14px",
    lineHeight: "1",
    fontWeight: "bold",
    width: "100%"
  }
}));

const MediaButton = (_ref, index) => {
  let buttonType = _ref.buttonType,
      _ref$icon = _ref.icon,
      icon = _ref$icon === void 0 ? "add" : _ref$icon,
      label = _ref.label,
      type = _ref.type,
      link = _ref.link,
      onClick = _ref.onClick,
      onUpload = _ref.onUpload,
      props = _objectWithoutPropertiesLoose(_ref, ["buttonType", "icon", "label", "type", "link", "onClick", "onUpload"]);

  const classes = useStyles();

  if (onUpload) {
    return React.createElement(UploadButton, _extends({}, props, {
      onUpload: onUpload,
      className: classes.root
    }), React.createElement(Typography, {
      nowrap: true,
      className: classes.label
    }, label));
  }

  return React.createElement(ButtonBase, {
    className: classes.root,
    onClick: onClick
  }, React.createElement(Typography, {
    className: classes.label
  }, label));
};

export default MediaButton;